import { registerComponent } from "helpers";
import SearchspringComponent from "searchspring";

registerComponent(
  "results-grid",
  class ResultsGrid extends SearchspringComponent {
    siteIDMapping = {
      [WYATT.config.searchspring.siteIds.products]: "products",
      [WYATT.config.searchspring.siteIds.articles]: "articles",
      [WYATT.config.searchspring.siteIds.pages]: "pages",
    };

    constructor() {
      super();

      this.template = this.querySelector('[data-template="item"]');
      this.noResultsTemplate = this.querySelector(
        '[data-template="no-results"]',
      );
      this.gridContentTemplate = this.querySelector(
        '[data-template="grid-content"]',
      );
    }

    get siteId() {
      return this.SearchPage.formData.get("siteId");
    }

    render({ results }) {
      this.replaceChildren();

      if (!results || results.length === 0) {
        if (this.noResultsTemplate) {
          const noResults = this.noResultsTemplate.content.cloneNode(true);
          this.appendChild(noResults);
        }
        return;
      }

      this.className = `results-grid results-grid--${this.siteIDMapping[this.siteId]}`;

      results.forEach((result) => {
        const item = this.template.content.cloneNode(true).firstElementChild;

        switch (this.siteIDMapping[this.siteId]) {
          case "products":
            item.innerHTML = `<product-summary data-handle="${result.handle}"></product-summary>`;
            break;
          case "articles":
            item.innerHTML = `<article-summary data-handle="${result.brand}/${result.uid}"></article-summary>`;
            break;
          case "pages":
            item.innerHTML = `<a href="${result.url}" class="results-grid__item-link">${result.name}</a>`;
            break;
          default:
            item.innerHTML = `<a href="${result.url}" class="results-grid__item-link">${result.name}</a>`;
            break;
        }

        this.appendChild(item);

        item.addEventListener("click", this.handleClick.bind(this, result));
      });

      if (this.gridContentTemplate) {
        const gridContent = this.gridContentTemplate.content.cloneNode(true);

        document.importNode(gridContent, true);
      }
    }

    handleClick(result) {
      if (
        !IntelliSuggest ||
        !result.intellisuggestData ||
        !result.intellisuggestSignature
      ) {
        return;
      }

      IntelliSuggest.clickItem(this, {
        siteId: this.siteId,
        intellisuggestData: result.intellisuggestData,
        intellisuggestSignature: result.intellisuggestSignature,
      });
    }
  },
);
